import type { OnboardingItemStatus as ApiOnboardingItemStatus } from '@datarecs/data-models-core-api';

/**
 * Browser-safe mirror of the `OnboardingItemStatus` enum.
 *
 * `OnboardingItemStatus` is a runtime *value* and is NOT in `@datarecs/data-models-core-api`'s
 * browser-safe entrypoint, so value-importing it from the package barrel drags the NestJS/swagger
 * server module graph (crypto, path, class-transformer) into the browser bundle and breaks
 * `ng build` — see `docs/data-models-imports.md` ("Enums") and the `ConnectionType` precedent in
 * `core/models/connection.model.ts`. Import the enum's *type* only, and use this const for the
 * runtime values. The casts keep compile-time safety against an upstream rename of a member.
 */
export type OnboardingItemStatus = ApiOnboardingItemStatus;
export const OnboardingItemStatus = {
    SEEN: 'SEEN' as ApiOnboardingItemStatus.SEEN,
    COMPLETED: 'COMPLETED' as ApiOnboardingItemStatus.COMPLETED,
    DISMISSED: 'DISMISSED' as ApiOnboardingItemStatus.DISMISSED,
} as const;
